import { render, staticRenderFns } from "./CreateCampaignSourceFavorites.vue?vue&type=template&id=f5d696b4&scoped=true"
import script from "./CreateCampaignSourceFavorites.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceFavorites.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceFavorites.vue?vue&type=style&index=0&id=f5d696b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d696b4",
  null
  
)

export default component.exports